import { createAction } from '@reduxjs/toolkit';

export const sessionEnded = createAction('session/ended');
export const merchantAttachStarted = createAction<{ merchantId: string }>('session/merchantAttachStarted');
